import * as types from './mutations-types'

export default {
  [types.CANCEL_RECORD_LIST] (state, data) {
    let compare = function () {
      return function (objAfter, objBefore) {
        let val1 = objAfter['id']
        let val2 = objBefore['id']
        return val2 - val1
      }
    }
    console.log(data.sort(compare()), 'data.sort(compare())')
    state.cancelRecordList = data.sort(compare())
  },
  [types.UPDATE_COUPON_INFO_RECORD] (state, data) {
    state.cancelRecordList = state.cancelRecordList.map(item => {
      if (item.id === data.id) {
        item.state = true
      }
      return item
    })
  },
  [types.UPDATE_COUPON_INFO_FALSE_RECORD] (state, data) {
    state.cancelRecordList = state.cancelRecordList.map(item => {
      if (item.id === data.id) {
        item.state = false
      }
      return item
    })
  },
  [types.STAFF_INFO] (state, data) {
    state.staffInfos = data
  },
  [types.MEMBER_APPOINTMENT_DATA] (state, data) {
    state.appointmentRecord = data
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/cancel-coupon/store/mutations.js